import { validateText } from '../mixins/component/validateText';
import { validateNumber } from '../mixins/component/validateNumber';
import { ref, getCurrentInstance, computed } from 'vue';
import { validateCombobox } from '../mixins/component/validateCombobox';
import i18nValidate from '@/i18ns/vi/i18nValidate';
export const useValidateControl = ({ props }) => {
  const errorMessage = ref('');
  const isValidate = computed(() => props.rules.length > 0);
  const { proxy } = getCurrentInstance();
  const validate = () => {
    //Nếu là editor của grid thì sẽ lấy config từ column
    let rules = [];
    if (proxy._isGridEditor) {
      rules = props.col.rules;
    } else {
      rules = props.rules;
    }
    let message = '';
    if (Array.isArray(rules) && rules.length > 0) {
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index];
        if (rule) {
          const { name, compareValue, customValidate } = rule;
          const controlValue = getValueControl();
          //Nếu có custom validate sẽ lấy theo customvalidate
          if (customValidate && typeof customValidate === 'function') {
            message = customValidate(
              controlValue,
              compareValue,
              getTitleError()
            );
            if (message) {
              break;
            }
          } else {
            message = handlerRule(name, controlValue, compareValue);
            if (message) {
              break;
            }
          }
        }
      }
    }
    errorMessage.value = message;
    return message;
  };
  /**
   * Xử lý các rule validate
   * @param {*} rule tên rule
   * @param {*} compareValue value
   * @returns
   */
  const handlerRule = (rule, controlValue, compareValue) => {
    let message = '';

    const titleError = getTitleError();
    switch (rule) {
      case 'required':
        if (
          controlValue === undefined ||
          controlValue === null ||
          controlValue === NaN ||
          controlValue === ''
        ) {
          message = i18nValidate.messages[rule](titleError, proxy._isGridEditor);
        }
        break;
      case 'moreThan':
        break;
      case 'lessThan':
        break;
      case 'equals':
        break;
      case 'pattern':
        if (!validateText.validateRule(compareValue, controlValue)) {
          message = i18nValidate.messages['email'](titleError);
        }
        break;
      case 'diffierentZero':
        if (!validateNumber.validatediffierentZero(controlValue)) {
          message = i18nValidate.messages['diffierentZero'](titleError);
        }
        break;
      default:
        break;
    }
    return message;
  };

  /**
   * Xử lý validate riêng cho combobox
   */
  const handlerValidateCombobox = () => {
    const { rules } = props;
    let message = '';
    if (Array.isArray(rules) && rules.length > 0) {
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index];
        if (rule) {
          const { name, compareValue, customValidate } = rule;
          message = validateCombobox.validateRule(name, proxy);
          if (message) {
            break;
          }
        }
      }
    }

    errorMessage.value = message;

    return message;
  };

  const clearValidate = () => {
    errorMessage.value = '';
  };
  /**
   * Lấy value của control (Các control override hàm này)
   * @returns
   */
  const getValueControl = () => {
    return proxy.getValue();
  };

  /**
   * Lấy title của error
   * @returns
   */
  const getTitleError = () => {
    const { title } = props;
    if (proxy._isGridEditor) {
      return props.col.caption;
    }
    return title || getValidateName();
  };

  /**
   * Nếu control không khai báo name để hiển thị thông tin lỗi validate -> up parent find label
   */
  const getValidateName = () => {
    let fn = function(el, c) {
      if (!el || c > 10) {
        return null;
      }

      let labelEl = el.querySelector('label');
      if (labelEl) {
        return (labelEl.innerText || '').replace('*', '');
      }

      return fn(el.parentNode, c + 1);
    };

    return fn(proxy.$el, 0);
  };
  return {
    errorMessage,
    validate,
    handlerValidateCombobox,
    getTitleError,
    clearValidate,
    isValidate
  };
};
